var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"takequiz"},[_c('h2',[_vm._v(" "+_vm._s(_vm.lang.welcome))]),_c('button',{staticClass:"btn btn-lg btn-dark",on:{"click":function($event){return _vm.beginQuiz()}}},[_vm._v(_vm._s(_vm.lang.beginBtn))])])}
var staticRenderFns = []

export { render, staticRenderFns }